<template>
  <toast v-model="showToast" v-if="showToast" :msg="msg"></toast>
</template>
<script>
import Toast from '@/components/Toast'
import { fetchRedpacket, doRedpacket } from '@/services/mayiRedpacket'
import { errorReport } from '@/utils/index.js'
import tujiaRedirect from '@/utils/tujiaRedirect.js'
import mayiLogin from '@/utils/mayiLogin.js'
import { geocoder } from '@/services/mayiCity'
import { searchfilteritem } from '@/services/mayiFilter'

export default {
  mixins: [tujiaRedirect, mayiLogin],
  components: {
    Toast
  },
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    payLoad: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      showToast: false,
      msg: '',
      autoGetRedpacketId: this.$route.query.autoGetRedpacketId,
      remoteUrl: {},
      ids: [],
      uiItems: [],
      timeOutArray: [],
      interval: null,
      redpackets: []
    }
  },
  watch: {
    payLoad(newVal) { // 观察者，观察桥接响应对象
      if (newVal && newVal.toUse) {
        this.redirectToHouseListPage(newVal)
      }
      if (newVal && newVal.status === 1) {
        this.doRedpacketHandler(newVal.id)
      } else if (newVal && newVal.status === 3) {
        this.redirectToHouseListPage(newVal)
      } else if (newVal && newVal.status === 4) {
        this.doShowToast('好可惜，红包抢完了')
      }
    }
  },
  async mounted() {
    try {
      this.compProps.mate.items.forEach((redpacket) => {
        let item = null
        if (this.$root.isOldUser !== undefined && redpacket.userType && this.$root.isOldUser) {
          item = redpacket.oldUser
        } else if ((this.$root.isOldUser !== undefined && redpacket.userType && !this.$root.isOldUser) ||
          (this.$root.isOldUser === undefined && redpacket.userType)) {
          item = redpacket.newUser
        } else {
          item = redpacket
        }
        const idList = item.id.split(',')
        this.ids = this.ids.concat(idList)
        this.uiItems.push({
          ...item,
          flagId: idList[0]
        })
      })

      this.fetchRedpacket()
    } catch (e) {
      errorReport(e)
    }
  },
  beforeDestroy() {
    this.interval && clearInterval(this.interval)
  },
  computed: {
    /**
     * 是否从登陆页返回
     * @param {int} id 红包id
     */
    isFromLoginPage() {
      return window.localStorage.getItem('isFromLoginPage') && window.localStorage.getItem('isFromLoginPage') === '1'
    }
  },
  methods: {
    /**
     * 查询红包
     */
    async fetchRedpacket() {
      const ret = await fetchRedpacket(this.ids)
      if (ret && ret.errcode === 0) {
        let redpackets = []
        ret.data.redpacketActivities.forEach((item) => {
          const idx = this.uiItems.find((redpacket) => {
            return redpacket.flagId === item.activityConfigId
          })
          if (idx) {
            redpackets.push({
              ...item,
              ...idx
            })
          }
        })
        this.autoGetRedpacket(redpackets)
        this.beginTimeOut(redpackets)
        this.redpackets = redpackets

        this.$emit('init', redpackets)
      } else {
        this.$emit('init', [])
      }
    },
    /**
     * 领红包
     * @param {int} id 红包id
     */
    async doRedpacketHandler(id) {
      try {
        // 这个埋点方案不是很好。想想以后改进一下。其他地方同。
        if (window._vds && window._vds.track) {
          window._vds.track(`${this.$root.isMobile ? 'H5' : 'PC'}_coupons_cms`, {
            [`${this.$root.isMobile ? 'H5' : 'PC'}_coupons_cms_bian`]: id,
            'activityid_cms': this.$root.promotionId
          })
        }
        const requereRedPacketInfo = this.compProps.mate.privateProps.hasRedPackModel
        const hasDialog = this.compProps.mate.privateProps.hasDialog
        const idList = id.split(',')
        const ids = idList.map((item) => {
          return {
            activityCode: item,
            couponCode: ''
          }
        })
        const ret = await doRedpacket({ ids, requereRedPacketInfo })
        if (ret && ret.errcode === 0) {
          if (requereRedPacketInfo && !hasDialog) {
            // 领取成功，弹层展示获得的红包列表
            console.log('serviceCom:' + JSON.stringify(ret.data && ret.data.redPacketInfos))
            this.$emit('finish', { type: 'doRedpacketAndShowListToast', data: { id: id, recivedRepackList: (ret.data && ret.data.redPacketInfos) || [] } })
          } else if (hasDialog && !requereRedPacketInfo) {
            // 领取成功，展示立即使用弹窗
            this.$emit('finish', { type: 'receiveRedpacketAndShowListToast', data: { id: id } })
          } else {
            // 领取成功，toast提示语
            this.doShowToast('领取成功')
            this.$emit('finish', { type: 'doRedpacket', data: { id: id } })
          }
        } else if (ret && ret.errcode === 55004) {
          let autoGetRedpacketId = id
          this.mayiLogin({ autoGetRedpacketId })
        } else if (ret && ret.errcode === 165002) {
          // 去使用红包
          let redpacket = this.redpackets.find((item) => {
            return item.id === id
          })

          this.redirectToHouseListPage(redpacket)
          this.$emit('finish', { type: 'redpacketDone', data: { id: id } })
        } else if (ret && ret.errcode === 165001) {
          this.doShowToast('好可惜，红包抢完了')
          this.$emit('finish', { type: 'overRedpacket', data: { id: id } })
        } else {
          this.doShowToast(ret.errmsg)
        }
      } catch (e) {
        this.doShowToast('系统开小差了，一会再试试吧')
        errorReport(e)
      }
    },
    doShowToast(msg) {
      this.msg = msg
      this.showToast = true
    },
    /**
     * 自动领红包
     * @param {int} id 红包id
     */
    autoGetRedpacket(redpackets) {
      redpackets.forEach((item, index) => {
        // 从登陆页返回时，触发红包领取
        if (this.isFromLoginPage && this.autoGetRedpacketId && item.id === this.autoGetRedpacketId) {
          window.localStorage.removeItem('isFromLoginPage')
          this.doRedpacketHandler(item.id)
        }
      })
    },
    /**
     * 跳转至房屋列表
     */
    async redirectToHouseListPage(redpack) {
      let CITYREG = new RegExp(/CITYID/, 'g')
      let geoInfo = await geocoder({ parameter: {} })
      let _cds = decodeURIComponent(redpack.appLink).split('cds=')[1]
      let isSupportFilter = await searchfilteritem({ cityId: (geoInfo && geoInfo.data && geoInfo.data.cityId) || 48, filterValue: _cds || '' })
      let cityId = isSupportFilter.filterItem ? geoInfo.data.cityId : 48
      // 蚂蚁小程序新增红包立即使用跳转功能
      let cityName = isSupportFilter.data && isSupportFilter.data.filterItem ? geoInfo.data.cityName : '北京'
      let isOverSea = isSupportFilter.data && isSupportFilter.data.filterItem ? geoInfo.data.oversea ? 2 : 1 : 1
      let _maplink = redpack.mpLink && redpack.mpLink.replace(CITYREG, cityId).replace('城市名称', cityName).replace('城市类型', isOverSea)
      console.log('redirectToHouseListPage-redpack:', redpack)
      let redirectUrl = {
        mpLink: _maplink,
        appLink: redpack.appLink && redpack.appLink.replace(CITYREG, cityId),
        isJumpApp: this.compProps.mate.privateProps.isJumpApp
      }
      this.doRedirect(redirectUrl, true)
    },
    /**
     * 开始倒计时
     * @param {Object} redpackets 红包
     */
    beginTimeOut(redpackets) {
      this.timeOutArray = []
      redpackets.forEach((item) => {
        item.activityType === 3 && item.activityStatus === 1 && item.countDown && this.timeOutArray.push(parseInt(item.countDown / 1000, 10))
      })
      if (this.timeOutArray.length) {
        this.timeOuntRun()
      }
    },
    /**
     * 倒计时函数
     */
    timeOuntRun() {
      this.interval = setInterval(this.calculTime, 1000)
    },
    /**
     * 倒计时计算
     */
    calculTime() {
      this.timeOutArray.forEach((item, index) => {
        this.timeOutArray[index] = item - 1
        if (item === 0) {
          this.fetchRedpacket()
        }
      })
      this.timeOutArray.filter((item) => {
        return item > 0
      })
      if (this.timeOutArray.length === 0) {
        clearInterval(this.interval)
      }
    }
  }
}
</script>
